export default function getResource(label) {
    const resources = {
        pointsAvailable: points => `${points} points disponibles`,
        appliedMessage: (applied, remaining) => `${applied} points appliqués • ${remaining} points restants à échanger`
    };
    return resources[label];
}
